<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="formData" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="客户名称">
              {{ formData.userName || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="类型">
              {{ formData.depositType === '1' ? '贷款' : formData.depositType === '2' ? '还款' : '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="金额">
              {{ formData.depositChange == null ? '--' : formData.depositChange }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间">
              {{ formData.ctime || '--' }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="附件">
              <file-upload readonly v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button @click="$router.back()" class="global-button">返回</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'FinanceLoanDetail',
  data() {
    return {
      formData: {
        loanId: '',
        userId: '',
        userName: '',
        depositType: '',
        depositChange: null,
        ctime: '',
        fileList: []
      }
    }
  },
  computed: {
    loanId() {
      return this.$route.query.loanId
    }
  },
  created() {
    if (this.loanId) {
      this.loadDetails()
    }
  },
  methods: {
    loadDetails() {
      this.$axios.get(this.$apis.financeLoan.selectYxFinanceLoanByLoanId, {
        params: { loanId: this.loanId }
      }).then(res => {
        res.fileList = res.fileList || []
        this.formData = res
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.el-select,
.el-input,
.el-input-number {
  width: 95%;
}
</style>
